// extracted by mini-css-extract-plugin
export default {"textArea":"MultilineTextInput_textArea__i6wkq","label":"MultilineTextInput_label__emKZz"};